import styled from '@emotion/styled';

const NotFoundStyle = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 100px 40px 100px;
    .notFoundIMG {
        width: 250px;
        height: 261.468px;
    }
    .viewContent {
        margin-bottom: 70px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #4f4f4f;
        font-weight: 400;
        line-height: 19.5px;
    }
`;

export default NotFoundStyle;
